import { canUseDOM } from '@ps/web-core-utils';

import type { Dispatch } from '@swf/core/store';

export const handleUnauthorisedRequest = (
  dispatch: Dispatch,
  isEmbedded: boolean,
  modalPath: string
) => {
  if (!canUseDOM) {
    return;
  }

  const dispatchLoggedOutModal = () => dispatch.modal.enqueue({ path: modalPath });

  if (isEmbedded) {
    /*
        Due to a race condition with the 'starslogout' event and the modal dispatch we
        want to ensure that the modal is only called after the logout is complete
      */
    document.addEventListener('starslogout', dispatchLoggedOutModal, { once: true });
    window.starsweb?.auth.logout();
  } else {
    dispatch.auth.logout();
    dispatchLoggedOutModal();
  }
};
